module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm.submission.id,
    staticClass: "rounded",
    class: [
      _vm.fromGenieRecap && _vm.isGenieRecap ?
      'bg-blueGray-100 border border-solid border-blueGray-200' :
      'bg-gray-100 border border-solid border-gray-200' ]
  }, [(!_vm.showModelSubmission && !_vm.studentInHardClosedRT) ? [(_vm.fromGenieRecap && _vm.isGenieRecap) ? _c('div', {
    staticClass: "px-10 pt-7 w-full"
  }, [(_vm.genieRecapQuestionInCurrentRT) ? _c('div', {
    staticClass: "mb-6"
  }, [_c('div', {
    staticClass: "mb-3.5"
  }, [_c('h6', {
    staticClass: "font-bold text-sm mb-1"
  }, [_vm._v("\n            Follow Up Questions (" + _vm._s(_vm.genieRecap.questions.length) + ")\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "text-blueGray-500 font-light font-poppins text-sm"
  }, [_vm._v("Leave a comment to respond to these follow up questions\n            below!")])]), _vm._v(" "), _vm._l((_vm.genieRecap.questions), function(q, index) {
    return _c('div', {
      key: index
    }, [_c('span', {
      staticClass: "flex items-center leading-7 text-gray-700 text-sm"
    }, [_vm._v("\n            " + _vm._s(index + 1) + ". " + _vm._s(q.question) + "\n          ")])])
  })], 2) : _vm._e()]) : _c('div', {
    staticClass: "px-10 pt-7 w-full"
  }, [(_vm.peer_guidance_questions_to_show.length) ? _c('div', {
    staticClass: "flex items-center mb-3",
    on: {
      "click": function($event) {
        _vm.collapsed_peer_guidance_questions = !_vm.collapsed_peer_guidance_questions
      }
    }
  }, [_c('h6', {
    staticClass: "font-bold text-sm"
  }, [_vm._v("\n          Feedback Questions (" + _vm._s(_vm.peer_guidance_questions_to_show.length) + ")\n          "), (_vm.collapsed_peer_guidance_questions) ? _c('i', {
    staticClass: "fas fa-arrow-down fa-sm ml-2"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up fa-sm ml-2"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.peer_guidance_questions_to_show.length && !_vm.collapsed_peer_guidance_questions),
      expression: "peer_guidance_questions_to_show.length && !collapsed_peer_guidance_questions"
    }],
    staticClass: "mb-6"
  }, _vm._l((_vm.peer_guidance_questions_to_show), function(question, index) {
    return _c('span', {
      key: index,
      staticClass: "flex items-center leading-7 text-gray-700 hover:text-primary text-sm",
      on: {
        "click": function($event) {
          return _vm.selectAutomatedFeedback(question)
        }
      }
    }, [_vm._v("\n          " + _vm._s(question) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-between px-10"
  }, [_c('div', {
    staticClass: "w-full h-full bg-white rounded focus-within:border-primary border border-coolGray-100 mb-8"
  }, [(!_vm.is_report_page) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment_content),
      expression: "comment_content"
    }],
    staticClass: "w-full outline-none h-32 px-4 rounded py-4",
    attrs: {
      "placeholder": "Leave a comment"
    },
    domProps: {
      "value": (_vm.comment_content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment_content = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex relative justify-between items-center border-t border-coolGray-200"
  }, [_c('EmojiPicker', {
    staticClass: "emoji-container ml-3",
    attrs: {
      "search": _vm.searchEmoji
    },
    on: {
      "emoji": _vm.append
    },
    scopedSlots: _vm._u([{
      key: "emoji-invoker",
      fn: function(ref) {
        var isMenuEmojisOpen = ref.events.click;

        return _c('div', {
          staticClass: "emoji-invoker"
        }, [_c('button', {
          staticClass: "w-8 h-8 hover:bg-coolGray-200 rounded-full",
          attrs: {
            "id": "openEmojiContainer"
          },
          on: {
            "click": isMenuEmojisOpen
          }
        }, [_c('i', {
          staticClass: "fa-solid text-base text-gray-500 fa-face-grin"
        })])])
      }
    }, {
      key: "emoji-picker",
      fn: function(ref) {
        var emojis = ref.emojis;
        var insert = ref.insert;

        return _c('div', {}, [_c('div', {
          staticClass: "emoji-picker absolute w-80 h-56 px-5 shadow rounded border border-coolGray-300 py-4 z-50 overflow-x-hidden overflow-y-auto bg-white"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.searchEmoji),
            expression: "searchEmoji"
          }],
          staticClass: "py-2 px-4 rounded w-full border-2 mb-3",
          attrs: {
            "placeholder": "Search",
            "type": "text"
          },
          domProps: {
            "value": (_vm.searchEmoji)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.searchEmoji = $event.target.value
            }
          }
        }), _vm._v(" "), _c('div', _vm._l((emojis), function(emojiGroup, category) {
          return _c('div', {
            key: category
          }, [_c('h5', [_vm._v(_vm._s(category))]), _vm._v(" "), _c('div', {
            staticClass: "emojis"
          }, _vm._l((emojiGroup), function(emoji, emojiName) {
            return _c('span', {
              key: emojiName,
              attrs: {
                "title": emojiName
              },
              on: {
                "click": function($event) {
                  return insert(emoji)
                }
              }
            }, [_vm._v("\n                        " + _vm._s(emoji) + "\n                      ")])
          }), 0)])
        }), 0)])])
      }
    }], null, false, 1196584339)
  }), _vm._v(" "), _c('button', {
    staticClass: "sample py-2 my-3 mr-3 w-28 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.postComment
    }
  }, [_vm._v("\n            Send\n          ")])], 1)])])] : _vm._e(), _vm._v(" "), (
    (_vm.showModelSubmission && _vm.canAddModelSubmission) || _vm.editModelSubmission
  ) ? _c('AddModelSubmission', {
    ref: "model-submission-textbox",
    attrs: {
      "id": "model-submission-in-comment",
      "modelID": _vm.model_id,
      "modelContent": _vm.model_content,
      "focusOnMounted": true,
      "submissionId": ("" + (_vm.submission.id))
    },
    on: {
      "closeModelSubmission": _vm.closeModelSubmission
    }
  }) : _vm._e(), _vm._v(" "), _c('CommentCardList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model_submission && _vm.showComments && !_vm.editModelSubmission),
      expression: "model_submission && showComments && !editModelSubmission"
    }],
    key: "model",
    staticClass: "transition delay-150 duration-300 ease-in-out",
    attrs: {
      "listOfComments": _vm.model_submission,
      "submission": _vm.submission,
      "submissionID": _vm.submission.id,
      "isInSummary": _vm.isInSummary
    }
  }), _vm._v(" "), _c('CommentCardList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        !_vm.getRTLoading.full_submission.includes(_vm.submission.id) && _vm.showComments
      ),
      expression: "\n      !getRTLoading.full_submission.includes(submission.id) && showComments\n    "
    }],
    key: "comments",
    staticClass: "mt-3 transition delay-150 duration-300 ease-in-out",
    attrs: {
      "listOfComments": _vm.ordered_submission_comments,
      "submission": _vm.submission,
      "submissionID": _vm.submission.id
    }
  }), _vm._v(" "), (_vm.fromGenieRecap && _vm.isGenieRecap) ? _c('CommentCardList', {
    key: "recap-comments",
    staticClass: "mt-3 transition delay-150 duration-300 ease-in-out",
    attrs: {
      "listOfComments": _vm.recapComments,
      "fromGenieRecap": true
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-204c029d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/commentsTab.vue
// module id = 1098
// module chunks = 61